import { TextField } from "src/components/FormikComponents/TextField";
import { CheckboxField } from "src/components/FormikComponents/CheckboxField";
import { useState } from "react";

interface IDefinitionCheckinOffsetProps {
  initialValue: number;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const DefinitionCheckInOffset = (props: IDefinitionCheckinOffsetProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;

  // Default to Auto when no offset has been set — covers freshly-created
  // definitions where checkInOffset is undefined and treats "no offset" as
  // the same thing as auto.
  const [checkinAuto, setCheckinAuto] = useState<boolean>(initialValue == null);
  const isDirty = initialValue !== value;

  return (
    <>
      <TextField
        className={`checkinoffset_control no_arrows ${isDirty ? "dirty" : ""}`}
        label="Check In"
        value={value}
        onChange={(event: any) => onChange(event?.target?.value)}
        meta={{
          initialValue: initialValue,
          touched: isDirty,
        }}
        disabled={checkinAuto || disabled}
        type="number"
      />
      <CheckboxField
        className={"checkinoffset_control_checkbox"}
        label="Auto"
        name="checkin_auto"
        checked={checkinAuto}
        onChange={() => {
          setCheckinAuto(!checkinAuto);
          if (!checkinAuto) {
            onChange(undefined);
          }
        }}
        disabled={disabled}
      />
    </>
  );
};
